import { useQuery } from "react-query";
import { getPreOrderUnitDetails, PreOrderDetailsUnit } from "Requests/PreOrder";

export const usePreOrderDetails = (id: number) => {
  return useQuery<PreOrderDetailsUnit>({
    queryFn: () => getPreOrderUnitDetails(id),
    queryKey: ["pre-order-detail-convertion", id],
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: 1,
    enabled: !!id,
  });
};
